import { PropsWithChildren } from 'react'

export const Layout = ({ children }: PropsWithChildren) => {
  return (
    <div
      className="flex min-h-screen w-full flex-col items-center bg-surface-secondary"
      data-testid="root-layout"
    >
      {children}
    </div>
  )
}
